<section class="hero" [id]="hero.id">

  <div class="hero-content">

    @if(hero.subtitle){
    <span class="subtitle">
      {{ hero.subtitle }}
    </span>
  }

    <h1>

      {{ hero.title }}

    </h1>

    @for (paragraph of hero.description; track paragraph) {
    <p>
      {{ paragraph }}
    </p>
    }

    <div class="hero-buttons">

      <a class="primary-btn" [href]="'#' + environment.FeatureConfig.id">
        {{ hero.primaryButton }}
      </a>

      <a class="secondary-btn" [href]="'#' + booking.id">
        {{ hero.secondaryButton }}
      </a>

    </div>

  </div>

</section>
